import { useLanguage } from "@/lib/language";
import type { Lang } from "@/lib/content";

type Bi = Record<Lang, string>;

export interface ArticleImage {
  src: string;
  alt: Bi;
}

export interface ArticleSectionLink {
  id: string;
  label: Bi;
}

export function EditorialImage({ image }: { image: ArticleImage; inverse?: boolean }) {
  const { t } = useLanguage();
  return (
    <figure className="min-w-0">
      <img
        src={image.src}
        alt={t(image.alt)}
        width={1200}
        height={800}
        fetchPriority="high"
        decoding="async"
        className="aspect-[3/2] w-full rounded-sm object-contain"
      />
    </figure>
  );
}

export function ArticleSidebar({
  points,
  sections,
}: {
  points?: Bi[];
  sections?: ArticleSectionLink[];
}) {
  const { t } = useLanguage();
  return (
    <aside className="min-w-0 text-start lg:sticky lg:top-28 lg:self-start">
      {points && points.length > 0 && (
        <div className="border-t-2 border-primary pt-5">
          <h2 className="text-sm font-semibold text-foreground">
            {t({ en: "Before you decide", ar: "قبل اتخاذ القرار" })}
          </h2>
          <ul className="mt-4 space-y-4">
            {points.map((point) => (
              <li
                key={point.en}
                className="border-b border-border pb-4 text-sm leading-relaxed text-muted-foreground last:border-0"
              >
                {t(point)}
              </li>
            ))}
          </ul>
        </div>
      )}
      {sections && sections.length > 0 && (
        <div className="mt-8">
          <h2 className="text-sm font-semibold text-foreground">
            {t({ en: "In this guide", ar: "في هذا الدليل" })}
          </h2>
          <ul className="mt-3 space-y-1">
            {sections.map((section) => (
              <li key={section.id}>
                <span className="inline-flex min-h-11 items-center text-sm leading-relaxed text-muted-foreground">
                  {t(section.label)}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </aside>
  );
}
